import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class ApiUrlInterceptor implements HttpInterceptor {
  apiUrl: string;
  loginUrl: string;

  constructor() {
    this.apiUrl = environment.urlService;
    // this.apiUrl = environment.getApiUrl();
    // this.loginUrl = environment.getLoginUrl();
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const url: string = this.apiUrl;
    req = req.clone({ url: this.prepareUrl(req.url, url) });
    return next.handle(req);
  }

  private isAbsoluteUrl(url: string): boolean {
    const absolutePattern = /^https?:\/\//i;
    return absolutePattern.test(url);
  }

  private prepareUrl(url: string, apiUrl: string): string {
    url = this.isAbsoluteUrl(url) ? url : apiUrl + '/' + url;
    return url.replace(/([^:]\/)\/+/g, '$1');
  }
}
